import { getCorrectStrTime } from './getCorrectStrTime';

export const getCorrectTime = (time = '') => {
  const [hour, minutes] = time.split(':');

  return `${hour}:${getCorrectStrTime(Math.round(+minutes / 5) * 5)}:00`;
};
